'use client';
import React, { useEffect, useRef, useState } from 'react';

function useInView(threshold = 0.1) {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {if (entry.isIntersecting) setInView(true);},
      { threshold }
    );
    if (ref?.current) observer?.observe(ref?.current);
    return () => observer?.disconnect();
  }, [threshold]);
  return { ref, inView };
}

const blogPosts = [
{
  img: '/assets/images/post-1.png',
  title: 'L\'Importance du Suivi Médical Préventif en Côte d\'Ivoire',
  desc: 'COSA propose des programmes de prévention complets incluant bilans de santé, vaccinations et dépistages pour toute la famille.',
  alt: 'Médecin COSA réalisant un bilan de santé préventif'
},
{
  img: '/assets/images/post-2.png',
  title: 'La Télémédecine : Révolution des Soins de Santé en Afrique',
  desc: 'Grâce à la télémédecine, COSA permet à ses patients d\'accéder à des spécialistes qualifiés depuis leur domicile.',
  alt: 'Consultation médicale en télémédecine au centre COSA'
},
{
  img: '/assets/images/post-3.png',
  title: 'COSA Ananeraie : Un Centre Médical aux Standards Internationaux',
  desc: 'Découvrez notre centre phare à Yopougon, équipé d\'une unité mobile de radiologie et de 7 cabinets spécialisés.',
  alt: 'Centre médical COSA Ananeraie à Yopougon Côte d\'Ivoire'
}];


export default function OurBlog() {
  const { ref, inView } = useInView();

  return (
    <div className="our-blog">
      <div className="dentaire-container">
        {/* Section Title */}
        <div className="row section-row">
          <div className="col-lg-12">
            <div className="section-title" style={{ textAlign: 'center', marginBottom: 0 }}>
              <h3>actualités</h3>
              <h2><span>Nos Derniers</span> Articles Santé</h2>
              <p>Restez informé des dernières actualités médicales et des conseils santé de nos experts COSA.</p>
            </div>
          </div>
        </div>

        <div className="row" ref={ref}>
          {blogPosts?.map((post, i) =>
          <div key={post?.title} className="col-lg-4 col-md-6">
              <div
              className="blog-item"
              style={{
                opacity: inView ? 1 : 0,
                transform: inView ? 'translateY(0)' : 'translateY(30px)',
                transition: `opacity 0.6s ease ${i * 0.25}s, transform 0.6s ease ${i * 0.25}s`
              }}>
              
                <div className="post-featured-image">
                  <figure>
                    <a href="#" className="image-anime">
                      <img src={post?.img} alt={post?.alt} />
                    </a>
                  </figure>
                </div>
                <div className="post-item-body">
                  <h2><a href="#">{post?.title}</a></h2>
                  <p>{post?.desc}</p>
                </div>
                <div className="post-item-footer">
                  <a href="#" className="read-more-btn">lire la suite</a>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Star Icon */}
      <div className="icon-star-image">
        <img src="https://html.awaikenthemes.com/dentaire/images/icon-star.svg" alt="Star decoration" />
      </div>
    </div>);

}